var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/formik/~/lodash/_Symbol.js
// module id = 162
// module chunks = 0